import { render, staticRenderFns } from "./PlayerController.vue?vue&type=template&id=56d004c4&scoped=true&lang=pug&"
import script from "./PlayerController.vue?vue&type=script&lang=js&"
export * from "./PlayerController.vue?vue&type=script&lang=js&"
import style0 from "./PlayerController.vue?vue&type=style&index=0&id=56d004c4&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d004c4",
  null
  
)

export default component.exports